import * as React from 'react';
import { IconChevronLeft16, IconChevronRight16 } from '@cian/ui-kit';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, DotGroup } from 'pure-react-carousel';

import '../../../../node_modules/pure-react-carousel/dist/react-carousel.es.css';
import * as styles from './ResponsiveSlider.css';

export interface IRenderDotsParams {
  currentSlide: number;
  totalSlides: number;
}

export interface IResponsiveSliderProps {
  slides: React.ReactNode[];
  renderDots?: (params: IRenderDotsParams) => JSX.Element;
  size: { width: number; height: number };
  padding: number;
  withMargin?: boolean;
  onPrevButtonClick?(): void;
  onNextButtonClick?(): void;
}

export const ResponsiveSlider: React.FC<IResponsiveSliderProps> = ({
  slides,
  size,
  padding,
  renderDots,
  withMargin = true,
  onPrevButtonClick,
  onNextButtonClick,
}) => {
  return (
    <CarouselProvider
      naturalSlideWidth={size.width}
      naturalSlideHeight={size.height}
      totalSlides={slides.length}
      className={styles['carousel-provider']}
    >
      <div className={styles['carousel']} style={withMargin ? { margin: `0 ${padding}px` } : undefined}>
        <ButtonBack className={styles['button']} style={{ left: -padding }} onClick={onPrevButtonClick}>
          <IconChevronLeft16 />
        </ButtonBack>
        <div className={styles['slider']}>
          <Slider>
            {slides.map((slide, index) => (
              <Slide key={index} index={index}>
                {slide}
              </Slide>
            ))}
          </Slider>
        </div>
        <ButtonNext className={styles['button']} style={{ right: -padding }} onClick={onNextButtonClick}>
          <IconChevronRight16 />
        </ButtonNext>
      </div>
      {renderDots && <DotGroup renderDots={renderDots} />}
    </CarouselProvider>
  );
};
